module.exports = [
  "Maruti",
  "Hyundai",
  "Mahindra",
  "Citroen",
  "Tata",
  "Ford",
  "Honda",
  "Kia",
  "Toyota",
  "Renault",
  "MG",
  "Datsun",
  "Skoda",
  "Jeep",
  "Nissan",
  "BMW",
  "Volkswagen",
  "Mercedes Benz",
  "Land Rover",
  "Lamborghini",
  "Jaguar",
  "Lexus",
  "Rolls Royce",
  "Volvo",
  "Isuzu",
  "Audi",
  "Bugatti",
  "Porsche",
  "Mini",
  "Bentley",
  "Force",
  "Aston Martin",
  "Mitsubishi",
  "Maserati",
  "Ferrari",

  // Additional Brands
  "Chevrolet",
  "Fiat",
  "Opel",
  "Daewoo",
  "SsangYong",
  "Suzuki",
  "Infiniti",
  "Acura",
  "Genesis",
  "Lincoln",
  "Cadillac",
  "Buick",
  "GMC",
  "Chrysler",
  "Dodge",
  "Ram",
  "Tesla",
  "Polestar",
  "Lucid",
  "Rivian",
  "BYD",
  "NIO",
  "XPeng",
  "Zeekr",
  "Li Auto",
  "VinFast",
  "Abarth",
  "Alfa Romeo",
  "DS Automobiles",
  "Peugeot",
  "SEAT",
  "Cupra",
  "Smart",
  "Saab",
  "Subaru",
  "Mazda",
  "Daihatsu",
  "Scion",
  "Hummer",
  "Pontiac",
  "Saturn",
  "Mercury",
  "Oldsmobile",
  "Plymouth",
  "McLaren",
  "Pagani",
  "Koenigsegg",
  "Lotus",
  "Morgan",
  "Alpine",
  "Spyker",
  "Rimac",
  "GWM",
  "Haval",
  "Chery",
  "Geely",
  "BAIC",
  "JAC",
  "FAW",
  "Dongfeng",
  "Proton",
  "Perodua",
  "Mahindra Electric",
  "Ashok Leyland",
  "Eicher",
  "Others"
];